import React, { useState } from "react";
import {
  Input,
  Button,
  Badge,
  InputGroup,
  InputGroupAddon,
  Label,
} from "reactstrap";

const TagInputSection = ({
  label,
  placeholder,
  valueKey, // "siteNames" or "bundleIds"
  badgeColor = "info",
  formState,
  setFormState,
  error = "",
}) => {
  const [inputValue, setInputValue] = useState("");

  /* -------------------------
     Add item
  -------------------------- */
  const addItem = () => {
    if (!inputValue.trim()) return;

    const objectKey = valueKey === "siteNames" ? "url" : "bundleID";

    setFormState((prev) => ({
      ...prev,
      values: {
        ...prev.values,
        [valueKey]: [
          ...(prev.values[valueKey] || []),
          { [objectKey]: inputValue.trim() },
        ],
      },
      errors: {
        ...prev.errors,
        [valueKey]: "", // ✅ clear error on add
      },
    }));

    setInputValue("");
  };

  /* -------------------------
     Remove item
  -------------------------- */
  const removeItem = (index) => {
    setFormState((prev) => ({
      ...prev,
      values: {
        ...prev.values,
        [valueKey]: prev.values[valueKey].filter((_, i) => i !== index),
      },
    }));
  };

  /* -------------------------
     Handle typing
  -------------------------- */
  const handleChange = (e) => {
    setInputValue(e.target.value);

    // ✅ clear only this field's error
    setFormState((prev) => ({
      ...prev,
      errors: {
        ...prev.errors,
        [valueKey]: "",
      },
    }));
  };

  return (
    <>
      <Label>
        {label}
        <span className="text-danger ml-1">*</span>
      </Label>

      <InputGroup>
        <Input
          value={inputValue}
          placeholder={placeholder}
          onChange={handleChange}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              addItem();
            }
          }}
          invalid={Boolean(error)}
        />

        <InputGroupAddon addonType="append">
          <Button
            className="btn-gradient-primary"
            onClick={addItem}
            disabled={!inputValue.trim()}
          >
            Add
          </Button>
        </InputGroupAddon>
      </InputGroup>

      {/* Error message */}
      {error && <p className="text-warning small mt-1">{error}</p>}

      {/* Badges */}
      <div className="mt-2">
        {(formState.values[valueKey] || []).map((item, i) => (
          <Badge key={i} color={badgeColor} className="mr-2">
            {valueKey === "siteNames" ? item?.url : item?.bundleID}
            <span
              className="ml-2 pointer"
              style={{ cursor: "pointer" }}
              onClick={() => removeItem(i)}
            >
              ×
            </span>
          </Badge>
        ))}
      </div>
    </>
  );
};

export default TagInputSection;